import { render, staticRenderFns } from "./ModalAddItems.vue?vue&type=template&id=430e40c8"
import script from "./ModalAddItems.vue?vue&type=script&lang=js"
export * from "./ModalAddItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports